var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVioletD = function SvgVioletD(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 281,
    viewBox: "0 0 300 281",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "20.438%",
    x2: "79.091%",
    y1: "27.328%",
    y2: "82.497%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A175E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#985CD6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M361.625 105.342c-59.103 74.121-15.66 199.247-194.18 247.806C-11.076 401.707-28.88 564.001 30.825 668.105c59.706 104.105 208.283 138.36 314.578 106.62 78.45-23.426 106.244-81.763 192.472-137.938 86.229-56.174 91.955-41.454 204.136-113.186 74.058-47.355 87.309-142.517 84.127-192.635C815.469 162.901 688.604.741 546.714.755c-61.623.007-126.096 30.602-185.089 104.587"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "20.438%",
    x2: "79.091%",
    y1: "43.668%",
    y2: "59.077%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A175E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#985CD6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9,
    transform: "translate(0 -506)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M98.677 738.994c71.443 47.186 170.08 58.618 246.726 35.731 78.45-23.426 106.244-81.763 192.472-137.938 51.646-33.645 74.413-41.858 108.47-58.446-59.199-42.239-132.639-67.244-212.191-67.244-155.238 0-287.207 95.218-335.477 227.897",
    mask: "url(#d)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVioletD);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/violet-d.b2264b9158980022bb0f224eb30dbbcd.svg";